import { useTranslation } from 'react-i18next';
import { WifiOff } from 'lucide-react';
import { useOnlineStatus } from '@/shared/hooks/use-online-status';

/**
 * Full-width amber banner shown when the browser loses network connectivity.
 * Automatically hides when connectivity is restored.
 */
export function OfflineBanner() {
  const { t } = useTranslation('common');
  const isOnline = useOnlineStatus();

  if (isOnline) return null;

  return (
    <div
      role="alert"
      aria-live="assertive"
      className="flex items-center gap-3 bg-amber-600 px-4 py-2 text-sm font-medium text-white"
    >
      <WifiOff className="h-4 w-4 shrink-0" />
      <span>{t('offline.message', 'No connection — using cached data')}</span>
    </div>
  );
}
